export default "__VITE_ASSET__Bvf8ugfG__"